<template>
	<circle cx="7.9999" cy="7.9999" r="1.6" fill="currentColor" />
	<path
		d="M12.2743 3.00329C12.4559 3.14902 12.6314 3.30609 12.7998 3.47452C15.2992 5.97387 15.2992 10.0261 12.7998 12.5255C12.6314 12.6939 12.4559 12.851 12.2743 12.9967M3.72538 3.0033C3.5438 3.14902 3.36832 3.30609 3.1999 3.47452C0.700547 5.97387 0.700547 10.0261 3.1999 12.5255C3.36832 12.6939 3.5438 12.851 3.72538 12.9967"
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
		fill="none"
	/>
	<path
		d="M10.7999 5.45442C12.2057 6.8603 12.2057 9.1397 10.7999 10.5456M5.1998 10.5456C3.79392 9.1397 3.79392 6.8603 5.1998 5.45442"
		stroke="currentColor"
		stroke-width="1.5"
		stroke-linecap="round"
		stroke-linejoin="round"
		fill="none"
	/>
</template>
